<div class="d-flex flex-row align-items-center justify-content-center" [class]="showCloseButton ? 'px-5 my-2' : ''">
  <div class="input-group autocomplete-container" role="combobox" aria-haspopup="listbox" [attr.aria-expanded]="showResults">
    <input
      #searchInput
      type="text"
      autocomplete="off"
      class="form-control"
      [class]="cssClass"
      [placeholder]="placeholder"
      [attr.aria-label]="placeholder"
      [(ngModel)]="searchQuery"
      (input)="onSearchInput($event)"
      (focus)="onSearchFocus()"
      (blur)="onSearchBlur()"
      (keyup.enter)="onSearch(searchQuery)"
    />
    <span class="input-group__btn">
      <button class="btn btn--primary Spa_Style_PrimaryButton" aria-label="Search" (click)="onSearch(searchQuery)">
        <i class="fas fa-search"></i>
      </button>
    </span>
    <div class="autocomplete-results" *ngIf="showResults">
      <div class="autocomplete-item" *ngFor="let drug of searchResults; trackBy: trackByDrugId" (click)="selectDrug(drug)">
        <div class="drug-name">{{ drug.drugName }}</div>
        <div class="drug-generic" *ngIf="drug.genericDrugName">{{ drug.genericDrugName }}</div>
      </div>
    </div>
  </div>

  <app-link
    *ngIf="showCloseButton"
    class="ms-5"
    [title]="closeButtonText"
    [additionalIcon]="'close'"
    [isLinkButton]="true"
    [makeInlineBlock]="true"
    [alwaysUnderlined]="false"
    [noUnderlineOnHover]="true"
    [role]="LinkRoles.BUTTON"
    (onClick)="onClose()"
  >
  </app-link>
</div>
